

import { useCallback, useMemo, useState } from 'react';
import { getQuickCompatibility } from '../../services/synastryApi';

const DEFAULT_SIGN_A = 'leo';
const DEFAULT_SIGN_B = 'pisces';

function normalizeError(err) {
  if (!err) {
    return {
      message: 'No se pudo calcular la compatibilidad zodiacal.',
      status: 0,
      payload: null,
    };
  }

  return {
    message:
      err.message ||
      'No se pudo calcular la compatibilidad zodiacal.',
    status: Number(err.status || 0),
    payload: err.payload || null,
  };
}

export default function useSynastryQuick(initialState = {}) {
  const [signA, setSignA] = useState(initialState.signA || DEFAULT_SIGN_A);
  const [signB, setSignB] = useState(initialState.signB || DEFAULT_SIGN_B);

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const canSubmit = useMemo(() => {
    return Boolean(signA && signB && !loading);
  }, [signA, signB, loading]);

  const calculate = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await getQuickCompatibility(signA, signB);
      setResult(data);
      return data;
    } catch (err) {
      const normalized = normalizeError(err);
      setError(normalized);
      return null;
    } finally {
      setLoading(false);
    }
  }, [signA, signB]);

  const reset = useCallback(() => {
    setSignA(initialState.signA || DEFAULT_SIGN_A);
    setSignB(initialState.signB || DEFAULT_SIGN_B);
    setLoading(false);
    setResult(null);
    setError(null);
  }, [initialState.signA, initialState.signB]);

  return {
    signA,
    signB,
    setSignA,
    setSignB,
    loading,
    result,
    error,
    canSubmit,
    calculate,
    reset,
  };
}